import { useTranslation } from 'react-i18next';

import { FeaturedIcon, Modal } from '@unified-checkout/design-system';
import { CircleInfo } from '@unified-checkout/design-system/icons/index';

interface IInstantRefundTermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function InstantRefundTermsModal({
  isOpen,
  onClose,
}: IInstantRefundTermsModalProps) {
  const { t } = useTranslation('card');

  return (
    <Modal
      open={isOpen}
      headerIcon={<FeaturedIcon icon={CircleInfo} color="primary" size="xl" />}
      title={t('REFUND_TERMS')}
      hasCloseIcon={true}
      onCloseHandler={onClose}
      width="35rem"
      position="center"
    >
      <div className="flex flex-col gap-4 p-6 pb-10">
        <div className="flex flex-col gap-[0.125rem]">
          <p className="text-base font-semibold leading-7 text-gray-900">
            {t('WHAT_REFUND')}
          </p>
          <p className="text-sm font-normal leading-[1.125rem] text-gray-600">
            {t('RECEIVE_REFUND')}
          </p>
        </div>
        <div className="flex flex-col gap-[0.125rem]">
          <p className="text-base font-semibold leading-7 text-gray-900">
            {t('FEE_STRUCTURE')}
          </p>
          <p className="text-sm font-normal leading-[1.125rem] text-gray-600">
            {t('NON_REFUNDABLE')}
          </p>
        </div>
        <div className="flex flex-col gap-[0.125rem]">
          <p className="text-base font-semibold leading-7 text-gray-900">
            {t('ELIGIBILITY')}
          </p>
          <p className="text-sm font-normal leading-[1.125rem] text-gray-600">
            {t('AVAILABLITY')}
          </p>
        </div>
        <div className="flex flex-col gap-[0.125rem]">
          <p className="text-base font-semibold leading-7 text-gray-900">
            {t('REFUND_PROCESS')}
          </p>
          <p className="text-sm font-normal leading-[1.125rem] text-gray-600">
            {t('REFUNDS_PROCESSED')}
          </p>
          <ul className="text-sm font-normal leading-[1.125rem] text-gray-600 pl-5">
            <li className="list-disc">{t('FEE_NON_REFUNDABLE')}</li>
            <li className="list-disc">{t('APPLICABLE')}</li>
          </ul>
        </div>
        <div className="flex flex-col gap-[0.125rem]">
          <p className="text-base font-semibold leading-7 text-gray-900">
            {t('POLICY_CHANGES')}
          </p>
          <p className="text-sm font-normal leading-[1.125rem] text-gray-600">
            {t('PAYMOB_RESERVES')}
          </p>
        </div>
        <p className="text-sm font-semibold leading-6 text-gray-500">
          {t('TERMS_OF_SERVICE')}
        </p>
      </div>
    </Modal>
  );
}

export default InstantRefundTermsModal;
